export default "__VITE_ASSET__875bdf1d__"